import { createContext, useContext, useState, useEffect } from "react";
import api from "../connector/api";

// 1. Export AuthContext so it can be imported directly if needed
export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() =>
    sessionStorage.getItem("access_token")
  );
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    if (token) {
      api.get('/accounts/me/')
        .then(res => setCurrentUser(res.data))
        .catch(err => console.error("Failed to load user:", err));
    }
  }, [token]);

  const login = (accessToken, permissions = []) => {
    sessionStorage.setItem("access_token", accessToken);
    sessionStorage.setItem("permissions", JSON.stringify(permissions));
    setToken(accessToken);
  };

  const logout = () => {
    sessionStorage.clear();
    setToken(null);
    setCurrentUser(null);
  };

  const canDeleteUniformLog = Boolean(
    currentUser?.is_superuser || 
    currentUser?.permissions?.includes?.('can_delete_student_uniform_log')
  );

  return (
    // 2. Include currentUser and canDeleteUniformLog in value!
    <AuthContext.Provider value={{ token, currentUser, canDeleteUniformLog, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);